var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentComponent)?_c(_vm.currentComponent,{tag:"component"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }